// extracted by mini-css-extract-plugin
export default {"market":"Market_market__9Z9jw","table":"Market_table__CjH14","row":"Market_row__V1HKF","col":"Market_col__EYSE4","foot":"Market_foot__AC1FI","arrow":"Market_arrow__2b7WZ"};